module.exports = __webpack_public_path__ + "img/jet-fighter.4aa11a17.svg";